<template>
  <v-dialog
    v-model="windowCam"
    overlay-opacity="0.90"
    width="80%"
    transition="slide-y-reverse-transition"
  >
    <v-card tile>
      <v-toolbar flat dark color="primary">
        <v-toolbar-title
          ><v-icon>mdi-cogs</v-icon> {{ config.cam }}</v-toolbar-title
        >
        <v-spacer />
        <v-toolbar-items>
          <v-btn color="" dark icon right @click="windowCam = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  name="cam"
                  v-model.trim="$v.config.cam.$model"
                  autocomplete="off"
                  :error-messages="camErr"
                  label="Câmera"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="url"
                  :value="config.url | decodeB64"
                  autocomplete="off"
                  :disabled="true"
                  label="Url"
                />
              </v-col>
              <v-col cols="12">
                <v-alert
                  border="left"
                  colored-border
                  elevation="1"
                  color="color_alert"
                  class="rounded-lg mb-4"
                >
                  <div class="py-4">
                    <h5
                      style="font-size: 17px"
                      class="d-flex flex-row justify-space-between"
                    >
                      Como funciona?
                      <v-icon @click="status_text = !status_text">{{
                        iconOPen(status_text)
                      }}</v-icon>
                    </h5>
                    <div class="ml-4 mt-4" v-show="status_text">
                      <p class="mb-0">
                        <v-icon class="mr-4">mdi-arrow-right-thin</v-icon>No 1º
                        campo você pode inserir o nome da sua câmera para você
                        organizar onde ela está monitorando
                      </p>
                      <p class="mb-0">
                        <v-icon class="mr-4">mdi-arrow-right-thin</v-icon>Aqui
                        abaixo você tem
                        <span class="font-weight-bold">os dias da semana</span>
                        e os <span class="font-weight-bold">eventos</span> para
                        você configurar os horários que vão ocorrer o
                        monitoramento das suas câmeras
                      </p>
                      <div class="w-100 pl-11 mt-0 pt-0">
                        <p class="mb-1" v-show="!status_dias_semana_text">
                          <span class="font-weight-bold">
                            Dias da semana:
                          </span>
                          ...
                          <v-btn
                            color="primary"
                            text
                            link
                            v-if="!status_dias_semana_text"
                            @click="
                              status_dias_semana_text = !status_dias_semana_text
                            "
                          >
                            {{
                              status_dias_semana_text ? "Ler Menos" : "Ler Mais"
                            }}</v-btn
                          >
                        </p>
                        <div v-show="status_dias_semana_text">
                          <span class="font-weight-bold">
                            Dias da semana:
                          </span>
                          Simples, você primeiro precisa...
                          <p class="py-0 my-0">
                            1. Selecionar o dia do monitoramento (domingo,
                            segunda,...);
                          </p>
                          <p class="py-0 my-0">
                            2. Clicar em “Início” e selecionar a hora que seu
                            monitoramento irá começar
                          </p>
                          <p class="mt-2 pl-4">
                            <span class="font-weight-bold">Atenção</span>, o dia
                            inicia às 00h e termina às 23h 59min. 59seg. então
                            se você quer monitorar a madrugada você precisa
                            selecionar das 00h até o horário que irá iniciar o
                            seu expediente, depois você pode selecionar um
                            horário de noite até finalizar o dia,
                          </p>
                          <p class="mt-2 pl-4">
                            Por exemplo: Segunda-feira sua empresa funciona das
                            8h às 18h, e você quer monitorar a madrugada até sua
                            empresa abrir e depois voltar a monitorar quando o
                            movimento da avenida ou rua diminuir muito, às 21h
                            por exemplo
                          </p>
                          <p class="mt-2 pl-4">
                            Você vai selecionar o dia Segunda > Início: 00:00 h
                            > Fim: 08:00 h > ADICIONAR, depois você vai
                            novamente para o Início: 21:00 h > Fim: 23:59:59 >
                            ADICIONAR.
                          </p>
                          <p class="mt-2 pl-4">
                            Isso é apena um exemplo para você entender como
                            planejar os horários de monitoramento, você pode
                            decidir quais são os horários que o Alertme irá
                            monitorar
                          </p>
                          <p class="mt-2 pl-4">
                            <span class="font-weight-bold"
                              >Para monitorar o dia inteiro:</span
                            >
                            Início: 00:00 > Fim: 23:59:59 > ADICIONAR
                          </p>
                          <p class="mt-2 pl-4">
                            <span class="font-weight-bold">OBS:</span>Se você
                            monitorar o dia inteiro, você pode receber muitas
                            imagens em horários de pico
                          </p>
                          <v-btn
                            color="primary"
                            text
                            link
                            @click="
                              status_dias_semana_text = !status_dias_semana_text
                            "
                          >
                            {{
                              status_dias_semana_text ? "Ler Menos" : "Ler Mais"
                            }}</v-btn
                          >
                        </div>
                        <div class="w-100 mt-0 pt-0">
                          <p class="mb-1" v-show="!status_evento_text">
                            <span class="font-weight-bold"> Eventos: </span> ...
                            <v-btn
                              color="primary"
                              text
                              link
                              v-if="!status_evento_text"
                              @click="status_evento_text = !status_evento_text"
                            >
                              {{
                                status_evento_text ? "Ler Menos" : "Ler Mais"
                              }}</v-btn
                            >
                          </p>
                          <div v-show="status_evento_text">
                            <p class="py-0 my-0">
                              <span class="font-weight-bold"> Eventos: </span>
                              Existe feriados e dias especiais que sua empresa
                              não vai trabalhar e você quer monitorar o dia
                              inteiro? Ou dias que normalmente você não
                              trabalha, mas a sua empresa vai abrir? Este é a
                              função dos Eventos
                            </p>
                            <p class="mt-2 pl-0">
                              Nos eventos você pode substituir horários de
                              monitoramentos em dias específicos
                            </p>
                            <p class="mt-2 pl-0">
                              Você pode clicar em EVENTOS > selecione o DIA, MÊS
                              e ANO (você pode salvar o dia mês de todos os
                              anos) > depois é só configurar o Início > Fim >
                              ADICIONAR e salvar todos os horários que você
                              precisa, depois é só clicar em SALVAR
                            </p>
                            <v-btn
                              color="primary"
                              text
                              link
                              class="px-0"
                              @click="status_evento_text = !status_evento_text"
                            >
                              {{
                                status_evento_text ? "Ler Menos" : "Ler Mais"
                              }}</v-btn
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-alert>
              </v-col>
              <v-tabs class="text-left" color="primary" vertical v-model="dias">
                <v-tab
                  v-for="(item, key) in config.cfg"
                  :key="key"
                  @click="loadInfoTabs(item, key)"
                  >{{ key | transformDia }}</v-tab
                >
                <v-tab-item
                  v-for="(item, key) in config.cfg"
                  :key="key"
                  class="pl-4"
                >
                  <h2 class="text-h5 primary--text">
                    {{ key | transformDia }}
                  </h2>
                  <div v-if="key != 'Specific'" class="col-8">
                    <v-row>
                      <v-col cols="12" md="5">
                        <v-select
                          v-model="start"
                          :items="listStart"
                          label="Inicio"
                        >
                          <template v-slot:item="data">
                            <v-icon>mdi-clock-time-four-outline</v-icon>
                            {{ data.item.text }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-select v-model="end" :items="listEnd" label="Fim">
                          <template v-slot:item="data">
                            <v-icon>mdi-clock-time-four-outline</v-icon>
                            {{ data.item.text }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="2" class="mt-3">
                        <v-btn
                          color="primary"
                          :disabled="
                            start != null && end != null ? false : true
                          "
                          @click="salvarHora"
                          block
                          >Adicionar</v-btn
                        >
                      </v-col>
                    </v-row>
                    <v-data-table
                      class="mt-4"
                      v-show="item.length > 0"
                      height="200"
                      :headers="headersDias"
                      :items="item"
                      :hide-default-footer="true"
                      fixed-header
                    >
                      <template v-slot:[`item.actions`]="{ index }">
                        <v-icon
                          color="red"
                          class="mx-1"
                          @click.prevent="removeHora(index)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </div>
                  <div v-else>
                    <v-btn color="primary" @click="newEvento"
                      >Novo Evento</v-btn
                    >
                    <v-data-table
                      v-show="item.length > 0"
                      height="200"
                      :headers="headersSpecif"
                      :items="item"
                      :hide-default-footer="true"
                      fixed-header
                    >
                      <template v-slot:[`item.actions`]="{ index }">
                        <v-icon
                          color="warning"
                          class="mx-1"
                          @click.prevent="editSpefic(index)"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon
                          color="red"
                          class="mx-1"
                          @click.prevent="removeSpecif(index)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </div>
                </v-tab-item>
              </v-tabs>
              <v-col cols="12">
                <p class="subtitle-1 mb-4">Definir cerca virtual</p>
                <canvas id="canvas" ref="canvas"></canvas>
                <v-col cols="12" class="px-0">
                  <v-btn
                    text
                    outlined
                    color="gray"
                    v-if="!editar_img"
                    class="mr-2"
                    @click="editar_img=true"
                    ><v-icon color="warning">mdi-pencil</v-icon> Editar</v-btn
                  >
                  <v-btn
                    color="primary"
                    v-if="editar_img"
                    class="mr-2"
                    @click="undoCerca"
                    ><v-icon>mdi-undo-variant</v-icon>Desfazer</v-btn
                  >
                  <v-btn
                    color="error"
                    @click="clearDraw"
                    v-if="editar_img"
                    class="mr-2"
                  >
                    <v-icon>mdi-delete</v-icon> Limpar cerca</v-btn
                  >
                </v-col>
              </v-col>
            </v-row>
          </v-container>
          <v-col cols="12">
            <v-btn
              color="success"
              block
              @click="salvarConfig"
              :disabled="$v.$invalid ? true : false"
              >Salvar</v-btn
            >
          </v-col>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogClose" max-width="320">
      <v-card>
        <v-card-title class="headline" color="primary">Aviso</v-card-title>

        <v-card-text>
          Existe informações que podem não ter sido salvas, deseja fechar assim
          mesmo?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1" text @click="closeFrmCam">
            fechar
          </v-btn>

          <v-btn color="success darken-1" text @click="salvarConfig">
            Salvar informações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSpefic" persistent max-width="400">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>Eventos</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn color="" dark icon right @click="dialogSpefic = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-form>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="diames"
                  :items="listDias"
                  label="Dia"
                  :disabled="itemSpecif.length > 0"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="mes"
                  :items="listMes"
                  :disabled="itemSpecif.length > 0"
                  @change="changeMes"
                  label="Mês"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="ano"
                  :items="listAno"
                  :disabled="itemSpecif.length > 0 || anualmente ? true : false"
                  @change="changeAno"
                  label="Ano"
                  class="mb-0 pb-0"
                />
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="anualmente"
                  label="Anualmente?"
                />
              </v-col>
              <v-col cols="12">
                <v-data-table
                  height="200"
                  :headers="headersDias"
                  :items="itemSpecif"
                  :hide-default-footer="true"
                  fixed-header
                >
                  <template v-slot:[`item.actions`]="{ index }">
                    <v-icon
                      color="red"
                      class="mx-1"
                      @click.prevent="removeHoraEvento(index)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>

              <v-col cols="12" md="4">
                <v-select v-model="start" :items="listStart" label="Inicio" />
              </v-col>
              <v-col cols="12" md="4">
                <v-select v-model="end" :items="listEnd" label="Fim" />
              </v-col>
              <v-col cols="12" md="2" class="mt-3">
                <v-btn color="primary" @click="salvarHoraEvento" block
                  >Adicionar</v-btn
                >
              </v-col>
              <v-btn color="success" block @click="salvarEvento"
                >Salvar Evento</v-btn
              >
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { existsProp, uuidv4 } from "../../services/utils";
export default {
  name: "FrmCam",
  data: () => ({
    editar_img: false,
    status_text: false,
    status_dias_semana_text: false,
    status_evento_text: false,
    dialogSpefic: false,
    dialogClose: false,
    anyEdit: false,
    windowCam: false,
    listStart: [],
    listEnd: [],
    listEdit: [],
    itemSpecif: [],
    indexSpecif: null,
    dias: 0,
    start: 0,
    end: 0,
    indexEdit: "Sunday",
    canvas: null,
    ctx: null,
    bisexto: false,
    ano: null,
    mes: null,
    diames: null,
    loadImg: null,
    offsetx: null,
    offsety: null,
    headersDias: [
      { text: "Inicio", value: "start", sortable: false },
      { text: "Fim", value: "end", sortable: false },
      { text: "Ações", value: "actions", sortable: false },
    ],
    headersSpecif: [
      { text: "Ano", value: "year", sortable: false },
      { text: "Mes", value: "month", sortable: false },
      { text: "Dia", value: "day", sortable: false },
      { text: "Ações", value: "actions", sortable: false },
    ],
    listAno: [],
    listMes: [],
    listDias: [],
    anualmente: false,
    validCerca: true,
    config: {
      cam: "",
      url: "",
      img: "",
      ver: { x: [], y: [] , w_x: [], w_y: [] },
      cfg: {
        Sunday: [],
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Specific: [],
      },
    },
  }),
  created() {
    this.createTimes();
  },
  filters: {
    transformDia: (value) => {
      if (!value) return "";
      value = value.toString();
      let transform = value;
      switch (value.toLowerCase()) {
        case "sunday":
          transform = "Domingo";
          break;
        case "monday":
          transform = "Segunda";
          break;
        case "tuesday":
          transform = "Terça";
          break;
        case "wednesday":
          transform = "Quarta";
          break;
        case "thursday":
          transform = "Quinta";
          break;
        case "friday":
          transform = "Sexta";
          break;
        case "saturday":
          transform = "Sábado";
          break;
        case "specific":
          transform = "Eventos";
          break;
      }
      return transform;
    },
    decodeB64(value) {
      return value != null && value.length > 0 ? window.atob(value) : "";
    },
  },
  props: ["content", "openFrm", "idx"],
  validations: {
    config: {
      cam: { required },
    },
  },
  computed: {
    camErr() {
      const errors = [];
      const item = this.$v.config.cam;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("Descrição câmera é obrigatório");
      return errors;
    },
  },
  mounted() {
    this.loadCanvas();
  },
  updated() {
    this.loadCanvas();
  },
  methods: {
    iconOPen(status) {
      return "mdi-chevron-" + (status ? "up" : "down");
    },
    changeAno() {
      let ano = this.ano;
      this.bisexto = ano % 4 == 0 && (ano % 100 != 0 || ano % 400 == 0);
    },
    changeMes() {
      let days = [30, 31];
      let m = this.mes - 1;
      let qtd = 28;
      if (m == 1) {
        qtd =
          this.ano % 4 == 0 && (this.ano % 100 != 0 || this.ano % 400 == 0)
            ? 29
            : 28;
      } else {
        qtd = days[(m + (m < 7 ? 1 : 0)) % 2];
      }
      this.listDias = [];
      for (let i = 1; i <= 31; i++) {
        let content = {};
        content.value = i;
        content.text = i;
        content.disabled = i > qtd;
        this.listDias.push(content);
      }
    },
    closeFrmCam() {
      this.dialogClose = false;
      this.anyEdit = false;
      this.windowCam = false;
    },
    organizeData(data) {
      let item = Object.assign({}, data);
      if (existsProp(item, "cfg")) {
        let cfg = {};
        cfg.Sunday = !existsProp(item.cfg, "Sunday") ? [] : item.cfg.Sunday;
        cfg.Monday = !existsProp(item.cfg, "Monday") ? [] : item.cfg.Monday;
        cfg.Tuesday = !existsProp(item.cfg, "Tuesday") ? [] : item.cfg.Tuesday;
        cfg.Wednesday = !existsProp(item.cfg, "Wednesday")
          ? []
          : item.cfg.Wednesday;
        cfg.Thursday = !existsProp(item.cfg, "Thursday")
          ? []
          : item.cfg.Thursday;
        cfg.Friday = !existsProp(item.cfg, "Friday") ? [] : item.cfg.Friday;
        cfg.Saturday = !existsProp(item.cfg, "Saturday")
          ? []
          : item.cfg.Saturday;
        cfg.Specific = !existsProp(item.cfg, "Specific")
          ? []
          : item.cfg.Specific;
        item.cfg = cfg;
      }
      if (existsProp(item, "ver")) {
          // ver: { x: [], y: [] , w_x: [], w_y: [] },
          if(!existsProp(item.ver, "x")) {
            item.ver.x=[]
          }
          if(!existsProp(item.ver, "w_x")) {
            item.ver.w_x=[]
          }
          if(!existsProp(item.ver, "y")) {
            item.ver.y=[]
          }
          if(!existsProp(item.ver, "w_y")) {
            item.ver.w_y=[]
          }
      }else{
        item.ver={ x: [], y: [] , w_x: [], w_y: [] }
      }
      return item;
    },
    salvarCerca() {
      let firts_x = this.config.ver.w_x[0];
      let firts_y = this.config.ver.w_y[0];
      //
      if (Number.isNaN(parseInt(firts_x)) || Number.isNaN(parseInt(firts_y))) {
        this.$store.dispatch(
          "setMsgError",
          "A cerca não foi definida corretamente, limpe o desenho e faça novamente!"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        this.validCerca = false;
        return;
      }
      let last_index = this.config.ver.w_x.length;
      if (last_index > 0) {
        --last_index;
        let last_x = this.config.ver.w_x[last_index];
        let last_y = this.config.ver.w_y[last_index];
        let diff_x = firts_x / last_x;
        let diff_y = firts_y / last_y;
        //
        if (
          diff_x < 0.95 ||
          diff_x > 1.05 ||
          diff_y < 0.95 ||
          diff_y > 1.05 ||
          last_index == 1
        ) {
          this.$store.dispatch(
            "setMsgError",
            "Cerca não foi definida corretamente!"
          );
          this.$store.dispatch("setDisplayMsgErr", true);
          this.validCerca = false;
          return false;
        }
        //
        let copy_x = [...this.config.ver.w_x];
        let copy_y = [...this.config.ver.w_y];
        copy_x.splice(last_index, 1);
        copy_y.splice(last_index, 1);
        this.config.ver.x = [...copy_x];
        this.config.ver.y = [...copy_y];
        //
      }
      this.validCerca = true;
    },
    clearDraw() {
      this.config.ver.w_y = [];
      this.config.ver.w_x = [];
      this.draw();
    },
    undoCerca() {
      //
      let last_index = this.config.ver.w_x.length;
      if (last_index > 0) {
        --last_index;
        let copy_x = this.config.ver.w_x;
        let copy_y = this.config.ver.w_y;
        copy_x.splice(last_index, 1);
        copy_y.splice(last_index, 1);
        this.config.ver.w_x = [...copy_x];
        this.config.ver.w_y = [...copy_y];
      } else {
        this.validCerca = true;
      }
      this.draw();
    },
    loadCanvas() {
      this.canvas = this.$refs.canvas; //document.getElementById("canvas");
      if (this.canvas == undefined || typeof this.canvas == Object) {
        //|| this.canvas != null
        return;
      }
      this.ctx = this.canvas.getContext("2d");
      this.loadImg = new Image();
      this.loadImg.onload = () => {
        this.canvas.width = this.loadImg.width;
        this.canvas.height = this.loadImg.height;
        this.ctx.drawImage(this.loadImg, 0, 0);
        this.draw();
      };
      this.loadImg.src = this.config.img;
      this.canvas.onmouseup = (e) => {
        if(!this.editar_img) {
          return 
        }
        e.preventDefault();
        e.stopPropagation();
        const rect = this.canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        this.config.ver.w_x.push(x);
        this.config.ver.w_y.push(y);
        this.validCerca = false;
        this.draw();
      };
    },
    draw() {
      this.canvas.width = this.loadImg.width;
      this.canvas.height = this.loadImg.height;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(this.loadImg, 0, 0);
      this.ctx.beginPath();
      this.ctx.strokeStyle = '#e0004d';
      this.config.ver.w_x.forEach((value, index) => {
        this.ctx.strokeRect(value, this.config.ver.w_y[index], 2, 2);
        this.ctx.lineTo(value, this.config.ver.w_y[index]);
      });
      this.ctx.lineWidth = 3;
      this.ctx.stroke();
    },
    parseMonth(value) {
      let mes = parseInt(value);
      let content = mes;
      switch (mes) {
        case 1:
          content = "Janeiro";
          break;
        case 2:
          content = "Fevereiro";
          break;
        case 3:
          content = "Março";
          break;
        case 4:
          content = "Abril";
          break;
        case 5:
          content = "Maio";
          break;
        case 6:
          content = "Junho";
          break;
        case 7:
          content = "Julho";
          break;
        case 8:
          content = "Agosto";
          break;
        case 9:
          content = "Setembro";
          break;
        case 10:
          content = "Outubro";
          break;
        case 11:
          content = "Novembro";
          break;
        case 12:
          content = "Dezembro";
          break;
      }
      return content;
    },
    createTimes() {
      this.listStart = [];
      this.listEnd = [];
      for (let i = 0; i <= 24; i++) {
        let content = {};
        let text = (parseInt(i) <= 9 ? "0" + i : i) + ":00 Hora";
        if(i==24) {
          text = '23:59 Hora'
        }
        content.value = i;
        content.text = text
        content.disabled = false;
        this.listStart.push(content);
        this.listEnd.push(content);
      }
      let ano = new Date().getFullYear();
      let max_ano = ano + 100;
      for (let i = ano; i <= max_ano; i++) {
        let content = {};
        content.value = i;
        content.text = i;
        content.disabled = false;
        this.listAno.push(content);
      }
      //

      for (let i = 1; i <= 12; i++) {
        let content = {};
        content.value = i;
        content.text = this.parseMonth(i);
        content.disabled = false;
        this.listMes.push(content);
      }

      for (let i = 1; i <= 31; i++) {
        let content = {};
        content.value = i;
        content.text = i;
        content.disabled = i >= 29;
        this.listDias.push(content);
      }
    },
    loadInfoTabs(item, index) {
      this.createTimes();
      this.indexEdit = index;
      this.listEdit = [...item];
    },
    checkExists(value) {
      if (this.listEdit > 0) {
        value.forEach((item) => {
          if (item.start < value || value < item.end) {
            return true;
          }
        });
      }
      return false;
    },
    salvarHora() {
      if (
        this.checkExists(this.start) ||
        this.checkExists(this.end) ||
        this.start == this.end ||
        this.start > this.end
      ) {
        this.$store.dispatch(
          "setMsgError",
          "Horário informado já foi utilizado ou inválido!"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }
      this.anyEdit = true;
      let content = { start: this.start, end: this.end };
      this.config.cfg[this.indexEdit].push(content);
      this.loadInfoTabs(this.config.cfg[this.indexEdit], this.indexEdit);
      this.start = null;
      this.end = null;
    },
    removeHora(index) {
      let item = [...this.config.cfg[this.indexEdit]];
      item.splice(index, 1);
      //
      this.anyEdit = true;
      this.config.cfg[this.indexEdit] = item;
      this.loadInfoTabs(this.config.cfg[this.indexEdit], this.indexEdit);
    },
    //metodos para eventos
    checkExistsEvento(value) {
      if (this.itemSpecif > 0) {
        value.forEach((item) => {
          if (item.start < value || value < item.end) {
            return true;
          }
        });
      }
      return false;
    },
    salvarHoraEvento() {
      if (
        this.checkExistsEvento(this.start) ||
        this.checkExistsEvento(this.end) ||
        this.start == this.end ||
        this.start > this.end
      ) {
        this.$store.dispatch(
          "setMsgError",
          "Horário informado já foi utilizado ou inválido!"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }
      this.anyEdit = true;
      let content = { start: this.start, end: this.end };
      this.itemSpecif.push(content);

      this.loadInfoTabs(this.itemSpecif, this.indexEdit);
      this.start = null;
      this.end = null;
    },
    removeHoraEvento(index) {
      let item = [...this.itemSpecif];
      item.splice(index, 1);
      //
      this.anyEdit = true;
      this.itemSpecif = item;
      this.loadInfoTabs(this.itemSpecif, this.indexEdit);
    },
    salvarEvento() {
      let _content = {
        year: this.anualmente ? null : this.ano,
        month: this.mes,
        day: this.diames,
        interval: this.itemSpecif,
      };
      if (this.indexSpecif != null) {
        this.config.cfg["Specific"][this.indexSpecif] = _content;
      } else {
        this.config.cfg["Specific"].push(_content);
      }
      this.dialogSpefic = false;
    },
    newEvento() {
      this.dialogSpefic = true;
    },
    editSpefic(index) {
      this.dialogSpefic = true;
      this.itemSpecif = [];
      this.indexSpecif = index;
      //
      let _content = this.config.cfg["Specific"][index];
      //
      this.ano = _content.year;
      this.mes = _content.month;
      this.diames = _content.day;
      this.anualmente = _content.year == null ? true : false;
      this.itemSpecif = _content.interval;
    },
    removeSpefic(index) {
      console.log(index);
    },
    getDate() {
      let datetime = new Date();
      let split = datetime.toISOString().split("T");
      return split[0] + " " + split[1].split(".")[0];
    },
    uuid() {
      return uuidv4();
    },
    salvarConfig() {
      this.salvarCerca();
      if (!this.validCerca) {
        this.$store.dispatch(
          "setMsgError",
          "Cerca não foi definida corretamente!"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }
      if (existsProp(this.config, "cfg")) {
        Object.keys(this.config.cfg).forEach((item) => {
          if (item != "Specific") {
            if (this.config.cfg[item].length <= 0) {
              this.config.cfg[item].push({ start: 0, end: 24 });
            }
          }
        });
      }
      this.anyEdit = false;
      let content = {
        cfg: Object.assign({}, this.config),
        idx: this.idx,
      };
      content.cfg.frm = false;
      this.windowCam = false;
      this.$emit("addCam", content);
      this.dialogClose = false;
    },
  },
  watch: {
    listEdit(value) {
      if (value.length > 0) {
        value.forEach((item) => {
          for (let i = item.start; i <= item.end; i++) {
            let index = i;
            this.listStart[index].disabled = true;
            this.listEnd[index].disabled = true;
          }
        });
      }
      // console.log(this.listStart)
    },
    openFrm(value) {
      this.windowCam = value;
      this.editar_img  =false
      
      if (value) {
        this.config = Object.assign({}, this.organizeData(this.content));
        this.loadCanvas();
      }
    },
    windowCam(value) {
      if (!value) {
        if (this.anyEdit) {
          this.windowCam = true;
          this.dialogClose = true;
          return false;
        }
        this.$emit("close");
      }
    },
    content(value) {
      this.anyEdit = false;
      this.config = Object.assign({}, value);
    },
    dias() {
      this.start = null;
      this.end = null;
    },
    anualmente(value) {
      if (value) {
        this.ano = null;
      }
    },
  },
};
</script>